import { useDataProviderRoot } from "src/mtska-frontend-data-provider";
import { useDrawer } from "../components";

const findLastStackEntry = (stack, rootKey) => {
    if (!Array.isArray(stack)) return null;
    for (let i = stack.length - 1; i >= 0; i--) {
        const entry = stack[i];
        if (entry && Object.keys(entry)[0] === rootKey) {
            return entry[rootKey];
        }
    }
    return null;
};

export const useRelationshipDiscoverer = (params, item, inverseRelation, stack) => {
    const { actives } = useDrawer()
    const { discover:dataProviderDiscover } = useDataProviderRoot();

    const discover = (fullKey) => {
        if (!fullKey || typeof fullKey !== 'string') return null;
    
        const keys = fullKey.split('.');
        const rootKey = keys[0];
        let result = null;

        // Precedence: params -> last stack -> inverseRelation -> item -> actives
        if (params && params[rootKey] !== undefined) {
            result = params[rootKey];
        }

        if (!result) {
            result = findLastStackEntry(stack, rootKey);
        }

        if (inverseRelation && inverseRelation[rootKey] !== undefined && !result) {
            result = inverseRelation[rootKey];
        }

        if (item && item[rootKey] !== undefined && !result) {
            result = item[rootKey];
        }

        const validDrawerRoutes = [rootKey+'s/detail'];
        if (actives && !result) {
            for (let i = actives.length - 1; i >= 0; i--) {
                const active = actives[i];
                if (active && validDrawerRoutes.includes(active.routeName)) {
                    const id = active?.params?.id ?? null;
                    result = dataProviderDiscover(id);
                    break;
                }
            }
        }

        if (!result) return null;

        for (let i = 1; i < keys.length; i++) {
            if (result && typeof result === 'object' && !Array.isArray(result)) {
                if (fullKey == 'person.employment') {
                    let parent = result;
                    result = result[keys[i]];
                    result = { ...result, person: { _id: parent._id, firstname: parent.firstname, lastname: parent.lastname } }
                } else {
                    result = result[keys[i]];
                }
            } else if (result && Array.isArray(result)) {
                const match = result.find(entry => typeof entry === 'object' && entry && keys[i] in entry);
                result = match ? match[keys[i]] : null;
            } else {
                return null;
            }
        }

        return result;
    };

    const discoverInStack = (key) => {
        return findLastStackEntry(stack, key);
    }

    const discoverAssignedModelForService = () => {
        if (discover('person.employment') ?? discover('employment')) return 'employee';
        if (discover('car')) return 'car';
        if (discover('contract')) return 'contract';
    }

    return {
        discover,
        discoverInStack,
        discoverAssignedModelForService
    }

};
